import { SearchableMenuBody } from './SearchableMenuBody';
import { SearchableMenuPopover } from './SearchableMenuPopover';
import { SearchableMenuProvider } from './SearchableMenuProvider';
import { SearchableMenuSearchHeader } from './SearchableMenuSearchHeader';
/**
 * A flexible, searchable dropdown menu component where search is handled externally.
 */
export function SearchableMenuControlled(props) {
    const { renderTarget, children, initiallyOpen = false, onClose, error = false, loading = false, onSearch, onReset, placeholder, items, } = props;
    return (<SearchableMenuProvider initiallyOpen={initiallyOpen} onClose={onClose} items={items} onReset={onReset} onSearch={onSearch} error={error} loading={loading}>
      <SearchableMenuPopover renderTarget={renderTarget}>
        <SearchableMenuSearchHeader placeholder={placeholder}/>
        <SearchableMenuBody>{children}</SearchableMenuBody>
      </SearchableMenuPopover>
    </SearchableMenuProvider>);
}
